import React from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import UserProfile from "../../services/user_profile.service";
import * as Yup from "yup";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import moment from "moment";
import { useEffect } from "react";
import CommonService from "../../services/common.service";
import PreviewImage from "../../Component/PreviewImage";
import ToastComponent from "../Common/TaostComponent";

const UpdateProfile = () => {
  const [hearAboutList, setHearAboutUs] = useState([]);
  const [result, setResult] = useState({});
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [batStyle, setBatStyle] = useState([]);
  const [bowlStyle, setBowlStyle] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState();
  const [introductionText, setIntroductionText] = useState("");
  const [playerAboutText, setPlayerAboutText] = useState("");

  useEffect(() => {
    CommonService.getUpdateProfileData().then((res) => {
      if (res.status === 200) {
        setHearAboutUs(res.hear_about_list);
        setResult(res.data);
        setSelectedCountry(res.data.country);
        setCountryList(res.country_list);
        setStateList(res.state_list);
        setIntroductionText(res.data.introduction);
        setPlayerAboutText(res.data.player_about);
        setBatStyle(res.batStyle);
        setBowlStyle(res.bowlStyle);
      }
    });
  }, []);
  const handleCountryChange = (e, setFieldValue) => {
    setSelectedCountry(e.target.value);
    setFieldValue("country", selectedCountry);
    CommonService.getStateFromCountryId(e.target.value).then((res) => {
      if (res.status === 200) {
        setStateList(res.data);
      }
    });
  };
  const handleIntroText = (e) => {
    setIntroductionText(e.target.value);
  };
  const handlePlayerAboutText = (e) => {
    console.log("asdasdas", e.target.value);
    setPlayerAboutText(e.target.value);
  };
  const navigate = useNavigate();
  const initialValues = {
    introduction: result?.introduction || "",
    tagline: result?.tagline || "",
    first_name: result?.first_name || "",
    last_name: result?.last_name || "",
    gender: result?.gender || "",
    about_us: result?.about_us || "",
    email: result?.email || "",
    dob: "",
    country: result?.country || "",
    state: result?.state || "",
    city: result?.city || "",
    team_name: result?.my_team_name || "",
    facebook: result?.facebook || "",
    twitter: result?.twitter || "",
    instagram: result?.instagram || "",
    website: result?.website || "",
    image: "",
    bat_style: result?.bat_style,
    bowl_style: result?.bowl_style,
    player_about: result?.player_about,
    player_image: result?.player_image ?? "",
  };
  const [loading, setLoading] = useState(false);
  const SUPPORTED_FORMATS = [
    "image/jpg",
    "image/png",
    "image/jpeg",
    "image/gif",
  ];
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email format")
      .required("Email field is required."),
    image: Yup.mixed()
      .nullable(true)
      .test(
        "fileSize",
        "File size too large, max file size is 5 Mb",
        (file) => {
          if (file) {
            return file.size <= 5500000;
          } else {
            return true;
          }
        }
      )
      .test(
        "type",
        "Invalid file format selection",
        (value) =>
          // console.log(value);
          !value || (value && SUPPORTED_FORMATS.includes(value?.type))
      ),
  });
  const onSubmit = (formValue) => {
    var formData = new FormData();
    formData.append("introduction", introductionText);
    formData.append("player_about", playerAboutText);
    formData.append("tagline", formValue.tagline);
    formData.append("first_name", formValue.first_name);
    formData.append("last_name", formValue.last_name);
    formData.append("gender", formValue.gender);
    formData.append("about_us", formValue.about_us);
    formData.append("email", formValue.email);
    formData.append("dob", formValue.dob);
    formData.append("country", selectedCountry);
    formData.append("state", formValue.state);
    formData.append("city", formValue.city);
    formData.append("team_name", formValue.team_name);
    formData.append("facebook", formValue.facebook);
    formData.append("twitter", formValue.twitter);
    formData.append("instagram", formValue.instagram);
    formData.append("website", formValue.website);
    formData.append("image", formValue.image);
    formData.append("bat_style", formValue.bat_style);
    formData.append("bowl_style", formValue.bowl_style);
    formData.append("player_image", formValue.player_image);
    CommonService.saveUpdateProfile(formData).then((res) => {
      if (res.status === 200) {
        localStorage.setItem("user", JSON.stringify(res.data));
        ToastComponent(res.message, "success");
        navigate("/my-games");
      }
    });
  };
  const [startDate, setStartDate] = useState(new Date());
  const [hearAboutUs, seHhearAboutUs] = useState();
  const handleDateChange = (date, setFieldValue) => {
    setStartDate(date);
    setFieldValue("dob", "start_date", moment(date).format("YYYY-MM-DD"));
  };
  const handleHereAboutUs = (value) => {
    seHhearAboutUs(value);
  };
  const handleProfile = (e, setFieldValue) => {
    setFieldValue("image", e.target.files[0]);
  };
  const handlePlayerImage = (e, setFieldValue) => {
    setFieldValue("player_image", e.target.files[0]);
  };
  const imagePath = process.env.REACT_APP_USER_PROFILE + result.image;
  return (
    <div className="middle-section">
      <div className="container">
        <div className="cms-section">
          <div className="heading">
            <h2>Edit Profile</h2>
          </div>
          <div className="whitebox">
            <div className="playerprofile-section">
              <div className="loginform">
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                  enableReinitialize={true}
                >
                  {({
                    errors,
                    handleChange,
                    values,
                    touched,
                    setFieldValue,
                  }) => (
                    <Form>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              name="first_name"
                              type="text"
                              className="form-control"
                              placeholder="First Name*"
                              onChange={handleChange}
                              id={"first_name"}
                            />
                            {touched.first_name && errors.first_name && (
                              <span className="help-inline error">
                                {errors.first_name}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              name="last_name"
                              type="text"
                              className="form-control"
                              placeholder="Last Name*"
                            />
                            {touched.last_name && errors.last_name && (
                              <span className="help-inline error">
                                {errors.last_name}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              as="select"
                              name="gender"
                              className="form-control"
                            >
                              <option value="">Select Gender</option>
                              <option value="1">Male</option>
                              <option value="2">Female</option>
                              <option value="3">Do not wish to specify</option>
                            </Field>
                            {touched.gender && errors.gender && (
                              <span className="help-inline error">
                                {errors.gender}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              as="select"
                              name="about_us"
                              className="form-control"

                              // value={hearAboutUs}
                            >
                              <option value="">Here about us?</option>
                              {hearAboutList &&
                                hearAboutList.map((item, key) => (
                                  <option
                                    value={item?.id}
                                    key={key}
                                    id={item.id}
                                  >
                                    {item?.name}
                                  </option>
                                ))}
                            </Field>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              name="email"
                              type="text"
                              className="form-control"
                              placeholder="Email*"
                            />
                            {touched.email && errors.email && (
                              <span className="help-inline error">
                                {errors.email}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <DatePicker
                              name="dob"
                              selected={startDate}
                              onChange={(date) =>
                                handleDateChange(date, setFieldValue)
                              }
                              className="form-control"
                              dateFormat={"dd/MM/yyyy"}
                              maxDate={new Date()}
                            />
                            {touched.dob && errors.dob && (
                              <span className="help-inline error">
                                {errors.dob}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              as="select"
                              name="country"
                              className="form-control"
                              onChange={(e) =>
                                handleCountryChange(e, setFieldValue)
                              }
                              value={selectedCountry}
                            >
                              <option value="">Select Country</option>
                              {countryList?.length >= 0 &&
                                countryList.map((item, key) => (
                                  <option
                                    value={item?.id}
                                    key={key}
                                    id={item.id}
                                  >
                                    {item?.name}
                                  </option>
                                ))}
                            </Field>

                            {touched.country && errors.country && (
                              <span className="help-inline error">
                                {errors.country}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              as="select"
                              name="state"
                              className="form-control"
                              // value={selectedCountry}
                            >
                              <option value="">Select State</option>
                              {stateList &&
                                stateList.map((item, key) => (
                                  <option
                                    value={item?.id}
                                    key={key}
                                    id={item.id}
                                  >
                                    {item?.name}
                                  </option>
                                ))}
                            </Field>
                            {touched.state && errors.state && (
                              <span className="help-inline error">
                                {errors.state}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              name="city"
                              type="text"
                              className="form-control"
                              placeholder="City*"
                            />
                            {touched.city && errors.city && (
                              <span className="help-inline error">
                                {errors.city}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              name="team_name"
                              type="text"
                              className="form-control"
                              placeholder="Set Your Fantasy Team Name*"
                            />
                            {touched.team_name && errors.team_name && (
                              <span className="help-inline error">
                                {errors.team_name}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Field
                              name="tagline"
                              type="text"
                              className="form-control"
                              placeholder="Tagline"
                            />
                            {touched.tagline && errors.tagline && (
                              <span className="help-inline error">
                                {errors.tagline}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Field
                              name="introduction"
                              as="textarea"
                              className="form-control"
                              placeholder="Introduction"
                              value={introductionText}
                              id="introduction"
                              onChange={handleIntroText}
                            />
                            {touched.introduction && errors.introduction && (
                              <span className="help-inline error">
                                {errors.introduction}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <h4 className="form_sec_heading">
                        Profile Picture (5mb)
                      </h4>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <div className="form-control customfiletype">
                              <input
                                name="image"
                                type="file"
                                value=""
                                onChange={(e) =>
                                  handleProfile(e, setFieldValue)
                                }
                              />
                              <Link>Profile Picture</Link>
                            </div>

                            {touched.image && errors.image && (
                              <span className="help-inline error">
                                {errors.image}
                              </span>
                            )}
                          </div>

                          {values.image ? (
                            <PreviewImage
                              className={{ margin: "auto" }}
                              width={100}
                              height={100}
                              file={values.image}
                            />
                          ) : (
                            <img
                              src={`${imagePath}`}
                              width={100}
                              height={100}
                              alt=""
                            />
                          )}
                        </div>
                      </div>
                      <br></br>

                      <h4 className="form_sec_heading">Social Links</h4>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              name="facebook"
                              type="text"
                              className="form-control"
                              placeholder="Facebook"
                            />
                            {touched.facebook && errors.facebook && (
                              <span className="help-inline error">
                                {errors.facebook}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              name="twitter"
                              type="text"
                              className="form-control"
                              placeholder="Twitter"
                            />
                            {touched.twitter && errors.twitter && (
                              <span className="help-inline error">
                                {errors.twitter}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              name="instagram"
                              type="text"
                              className="form-control"
                              placeholder="Instagram"
                            />
                            {touched.instagram && errors.instagram && (
                              <span className="help-inline error">
                                {errors.instagram}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              name="website"
                              type="text"
                              className="form-control"
                              placeholder="Website"
                            />
                            {touched.website && errors.website && (
                              <span className="help-inline error">
                                {errors.website}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <h4 className="form_sec_heading">
                        Player Profile Information
                      </h4>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              as="select"
                              name="bat_style"
                              className="form-control"
                            >
                              <option value={0}>Select Bat Style</option>
                              {batStyle &&
                                batStyle.map((item, key) => (
                                  <option value={item?.id} key={key}>
                                    {item?.name}
                                  </option>
                                ))}
                            </Field>
                            {touched.bat_style && errors.bat_style && (
                              <span className="help-inline error">
                                {errors.bat_style}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Field
                              as="select"
                              name="bowl_style"
                              className="form-control"
                            >
                              <option value={0}>Select bowl Style</option>
                              {bowlStyle &&
                                bowlStyle.map((item, key) => (
                                  <option value={item?.id} key={key}>
                                    {item?.name}
                                  </option>
                                ))}
                            </Field>
                            {touched.bowl_style && errors.bowl_style && (
                              <span className="help-inline error">
                                {errors.bowl_style}
                              </span>
                            )}
                          </div>
                        </div>
                        {/* <div className="col-sm-12">
                          <div className="form-group">
                            <div className="form-control customfiletype">
                              <input
                                name="player_image"
                                type="file"
                                value=""
                                onChange={(e) =>
                                  handlePlayerImage(e, setFieldValue)
                                }
                              />
                              <Link>Player Image</Link>
                            </div>

                            {touched.player_image && errors.player_image && (
                              <span className="help-inline error">
                                {errors.player_image}
                              </span>
                            )}
                          </div>

                          {values.player_image ? (
                            <PreviewImage
                              className={{ margin: "auto" }}
                              width={100}
                              height={100}
                              file={values.image}
                            />
                          ) : result.player_image !== null &&
                            result.player_image ? (
                            <img
                              src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${result.player_image}`}
                              width={100}
                              height={100}
                              alt=""
                            />
                          ) : (
                            <img src={`../images/user-img.png`} alt="img" />
                          )}
                        </div> */}
                        <div className="col-sm-12 pt-2">
                          <div className="form-group">
                            <Field
                              name="player_about"
                              as="textarea"
                              className="form-control"
                              placeholder="About me"
                              value={playerAboutText}
                              id="player_about"
                              onChange={handlePlayerAboutText}
                            />
                            {touched.player_about && errors.player_about && (
                              <span className="help-inline error">
                                {errors.player_about}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="text-center">
                        <button type="submit" className="btn btn-primary">
                          Save
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateProfile;
